import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';

const YEAR_PARAM = 'year';

/**
 * Reads/writes the selected financial year from the `?year=` URL param. Defaults to the current
 * year when the param is missing or invalid. Shared by the dashboard and reporting pages so the
 * selection is shareable and persists across navigation.
 */
export function useYearParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const yearParam = Number(searchParams.get(YEAR_PARAM));
  const selectedYear = Number.isInteger(yearParam) && yearParam > 0 ? dayjs().year(yearParam) : dayjs();

  const setSelectedYear = (value: dayjs.Dayjs | null) => {
    if (!value) return;
    setSearchParams(
      (prev) => {
        prev.set(YEAR_PARAM, String(value.year()));
        return prev;
      },
      { replace: true },
    );
  };

  return { selectedYear, setSelectedYear };
}
